import { createFetcher } from "api/helpers"

const fetcherConfiguration = {
  method: "post",
  makeRequestUrl: (host, project) => {
    return `${host}/cp/${project}/upload_project_report`
  },
  checkRequiredArguments: () => {},
  makeResponseData: (json) => {
    return json
  }
}
export default createFetcher(fetcherConfiguration)
